"use client";
// List of included Services Cleaning Categories Landing Pages;
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import * as v1Api from "../../services/api";


function IncludedServicesCLP() {
  const router = useRouter();
  const [open, setOpen] = useState("");
  interface Service {
    name: string;
  }

  interface OfferedServices {
    [key: string]: Service[];
  }

  const [offeredServices, setOfferedServices] = useState<OfferedServices>({});

  useEffect(() => {
    const loadServices = async () => {
      if (!router.isReady) return;

      const category = router.query.page?.[0];

      try {
        const data = await v1Api.fetchOfferedServices(category);
        setOfferedServices(data);
      } catch (error) {
        console.error("Error loading services:", error);
      }
    };
    loadServices();
  }, [router.isReady, router.query]);

  useEffect(() => {
    if (offeredServices) {
      const firstKey = Object.keys(offeredServices)[0];
      setOpen(firstKey);
    }
  }, [offeredServices]);

  const handleOpen = (value: string) => setOpen(open === value ? "" : value);

  const capitalizeFirstLetter = (str: string) =>
    str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <>
      <div className="md:hidden  my-4 mx-8">
        {offeredServices &&
          Object.entries(offeredServices).map(([areaKey, services]) => (
            <div
              key={areaKey}
              className="rounded-lg w-full mx-auto p-5 pr-8 mb-10 text-[#8C6F34] border border-[#8C6F34]"
            >
              <button
                type="button"
                onClick={() => handleOpen(areaKey)}
                className="flex w-full items-center text-[16px] text-[#8C6F34] font-light font-montserrat mb-2"
                aria-expanded={open === areaKey}
                aria-controls={`services-${areaKey}`}
              >
                {capitalizeFirstLetter(areaKey)}
                <MdKeyboardArrowDown
                  className={`text-2xl text-[#8C6F34] transition-transform ml-auto ${
                    open === areaKey ? "rotate-180" : ""
                  }`}
                />
              </button>
              {open === areaKey ? (
                <div id={`services-${areaKey}`}>
                  <ul className="list-disc space-y-1">
                    {services.map((service, index) => (
                      <li
                        key={areaKey + "_" + index}
                        className="flex items-center"
                      >
                        <span className="text-[#8C6F34] mr-2">&#10003;</span>
                        <span className="font-sans text-[12px] font-light">
                          {service.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}
            </div>
          ))}
      </div>
      <div className="invisible h-0 w-0 md:visible md:h-auto md:w-auto flex justify-center gap-8 my-4 mx-8 md:mx-0">
        {offeredServices &&
          Object.entries(offeredServices).map(([areaKey, services]) => (
            <div
              key={areaKey}
              className="rounded-lg w-full md:max-w-[250px] p-5 pr-8 text-[#3F4243] border border-[#8C6F34]"
            >
              <div>
                <h2 className="text-[16px] font-light font-montserrat text-[#8C6F34] mb-2">
                  {capitalizeFirstLetter(areaKey)}
                </h2>
                <div>
                  <ul className="list-disc  space-y-1">
                    {services.map((service, index) => (
                      <li
                        key={areaKey + "_" + index}
                        className="flex items-center"
                      >
                        <span className="text-[#8C6F34] mr-2">&#10003;</span>
                        <span className="font-sans text-[12px] font-light">
                          {service.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  );
}

export default IncludedServicesCLP;
